var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "48px",
    viewBox: "0 0 70 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image",
    fill: "#d1d1d1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4291237,16.625 L27.6301546,23.9948454 L51.5708763,3.73453608 L69.9909794,20.314433 L69.9909794,47.9445876 L0.00902061856,47.9445876 L0.00902061856,31.3646907 L18.4291237,16.625 Z M7.37886598,0.0541237113 C3.31056701,0.0541237113 0.00902061856,3.3556701 0.00902061856,7.42396907 C0.00902061856,11.492268 3.31056701,14.7938144 7.37886598,14.7938144 C11.4471649,14.7938144 14.7487113,11.492268 14.7487113,7.42396907 C14.7487113,3.3556701 11.4471649,0.0541237113 7.37886598,0.0541237113 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.a30cdb0fe23be7dd405eb61b2f88a337.svg";
export { ForwardRef as ReactComponent };